<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <IntervalReportByProduct
          v-show="this.$store.state.user.userGroup == 'admin'"
        />
      </div>
       <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <IntervalReportByOrder
          v-show="this.$store.state.user.userGroup == 'admin'"
        />
      </div>
    </div>
    <div class="vx-row">
       <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <ReportByYear
          v-show="this.$store.state.user.userGroup == 'admin'"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <ReportYearByUser
          v-show="this.$store.state.user.userGroup == 'admin'"
        />
      </div>
    </div>
    <div class="vx-row">
         <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <ReportByYears
          v-show="this.$store.state.user.userGroup == 'admin'"
        />
      </div>
         <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <ExportToXLSByOrder
          v-show="this.$store.state.user.userGroup == 'admin'"
        />
      </div>
    </div>
      <div class="vx-row">
         <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <ReportByYearsExcel
          v-show="this.$store.state.user.userGroup == 'admin'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IntervalReportByProduct from "./IntervalReportByProduct.vue";
import IntervalReportByOrder from "./IntervalReportByOrder.vue";
import ExportToXLSByOrder from "./ExportToXLSByOrder.vue";
import ReportByYear from "./ReportByYear.vue";
import ReportByYears from "./ReportByYears.vue";
import ReportYearByUser from "./ReportYearByUser"
import ReportByYearsExcel from "./ReportByYearsExcel.vue"
export default {
  components: {
    IntervalReportByProduct,
    IntervalReportByOrder,
    ReportByYear,
    ReportByYears,
    ReportYearByUser,
    ExportToXLSByOrder,
    ReportByYearsExcel
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  async created() {
    let payload = {
      loading: this.$vs.loading,
    };
    this.$store.dispatch("fetchAllUsers", payload);
  },
};
</script>

<style lang="scss">
</style>
